export enum OrganizationType {
  ADMIN = 'ADMIN',
  LABORATORY = 'LABORATORY',
  CUSTOMER = 'CUSTOMER'
}